import { Message } from 'element-ui'

const showMessage = Symbol('showMessage')

let messageInstance = null
export class DonMessage {
  success (options, single = true) {
    this[showMessage]('success', options, single)
  }
  warning (options, single = true) {
    this[showMessage]('warning', options, single)
  }
  info (options, single = true) {
    this[showMessage]('info', options, single)
  }
  error (options, single = true) {
    this[showMessage]('error', options, single)
  }
  [showMessage] (type, options, single) {
    if (messageInstance && single) {
      messageInstance.close()
    }
    messageInstance = Message[type](options)
  }
}

/**
 * @param {object} vm this
 * @param {string} name 名称的值
 * @param {string} fildeName 表单字段的key
 */
export function NameCheckBlur(vm, name, fildeName) {
  let str = ''
  if (name) {
    if (name.length >= 2 && /^[\u4e00-\u9fa5]+$/g.test(name)) {
      str = name
    } else {
      vm.$NewMessage.warning({
        message: '姓名的长度至少要在2个汉字及以上'
      })
      str = name.replace(/[^\u4E00-\u9FA5]/g,'')
      // if (fildeName && this.$refs[`${fildeName}Ref`]) this.$refs[`${fildeName}Ref`].focus()
    }
  }
  return str
}

/**
 * @param {object} vm this
 * @param {string} name 名称的值
 * @param {string} fildeName 表单字段的key
 */
export function NameCheck(vm, name, fildeName) {
  let flage = false
  if (name) {
    if (name && name.length >= 2 && /^[\u4e00-\u9fa5]+$/g.test(name)) {
      flage = false
    } else {
      flage = true
      vm.$NewMessage.warning({
        message: '姓名的长度至少要在2个汉字及以上'
      })
      // if (fildeName && this.$refs[`${fildeName}Ref`]) this.$refs[`${fildeName}Ref`].focus()
    }
  }
  return flage
}